<template>
  <div
    class="lazy-select-content-results-list-item d-flex align-items-center"
    :class="{ highlight, selected, loading, disabled }"
  >
    <AppCheckbox
      v-if="multiple"
      :value="selected"
      :disabled="disabled"
      @input="onItemInput"
    >
      <slot>{{ item.name }}</slot>
    </AppCheckbox>

    <div
      v-else
      class="single-item d-flex align-items-center m-0 w-full gap-10"
      @click="onItemInput"
    >
      <div
        class="radio"
        :class="{ checked: selected, disabled }"
      >
        <span />
      </div>
      <slot>{{ item.name }}</slot>
    </div>
  </div>
</template>

<script>
// @ts-check

export default {
  name: 'AppLazySelectItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    highlight: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onItemInput() {
      if (!this.disabled) {
        this.$emit('input', { ...this.item, selected: this.selected });
      }
    },
  },
};
</script>
